import { fetchError, getAPIPrefix, getLocalToken, uuid } from '.';

const workercode = () => {
  // importScripts(`http://localhost:9000${process.env.publicPath}/lib/js/eventsource.min.js`);

  function fetchAxiospost(eData) {
    fetch(eData.url, {
      method: 'POST',
      body: JSON.stringify(eData.data),
      headers: eData.config.headers,
    })
      .then((res) => res.json())
      .then((response) => {
        self.postMessage({
          uid: eData.uid,
          response,
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        self.postMessage({
          uid: eData.uid,
          error: error,
        });
      });
  }

  self.onmessage = function (e) {
    if (e.data.type === 'axiospost') {
      fetchAxiospost(e.data);
    }
  };

  self.postMessage('workerResult');
};

let code = workercode.toString();
code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

const blob = new Blob([code], { type: 'application/javascript' });
const worker_script = URL.createObjectURL(blob);

let workerRef = 0;

let workerInstance: Worker;

if (workerRef === 0) {
  workerInstance = new Worker(worker_script);
  workerRef++;
}

export const workerAxios = (url, data, config = {}) => {
  return new Promise((resolve, reject) => {
    const uid = uuid();
    const access_token = getLocalToken();
    const innerConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      ...config,
    };
    if (access_token) {
      innerConfig.headers.Authorization = access_token;
    } else {
      fetchError(200002); // 强制登录
    }
    const innerurl = getAPIPrefix(url);
    workerInstance.postMessage({
      type: 'axiospost',
      uid: uid,
      url: innerurl,
      data,
      config: innerConfig,
    });
    workerInstance.addEventListener('message', (e) => {
      const eData = e.data;
      if (uid !== eData.uid) return;
      if (eData.response) {
        resolve(eData.response);
      }
      if (eData.error) {
        reject(eData.error);
      }
    });
  });
};
